export const tradePlatforms = [
  { id: "xianyu", label: "闲鱼" },
  { id: "xiaohongshu", label: "小红书" },
  { id: "douyin", label: "抖音" },
  { id: "zhuanzhuan", label: "转转" },
  { id: "atrenew", label: "爱回收" },
  { id: "wechat", label: "微信" },
  { id: "offline", label: "线下" },
  { id: "other", label: "其他" }
] as const;

export type TradePlatform = (typeof tradePlatforms)[number]["id"];

export function translateTradePlatform(platform: string) {
  return tradePlatforms.find((item) => item.id === platform)?.label ?? platform;
}

export function tradeLotMargin(input: {
  buyPrice: number;
  buyQuantity: number;
  inboundFreight: number;
  buyConsumableCost?: number;
  buyMiscCost?: number;
  buyRefurbishmentCost?: number;
  salePrice: number;
  saleQuantity: number;
  outboundFreight: number;
  saleConsumableCost?: number;
  platformFee?: number;
  saleMiscCost?: number;
}) {
  const buyQuantity = Math.max(input.buyQuantity, 1);
  const saleQuantity = Math.max(input.saleQuantity, 0);
  const allocatedInbound = (Math.max(input.inboundFreight, 0) * saleQuantity) / buyQuantity;
  const allocatedBuyConsumable = (Math.max(input.buyConsumableCost ?? 0, 0) * saleQuantity) / buyQuantity;
  const allocatedBuyMisc = (Math.max(input.buyMiscCost ?? 0, 0) * saleQuantity) / buyQuantity;
  const allocatedRefurbishment = (Math.max(input.buyRefurbishmentCost ?? 0, 0) * saleQuantity) / buyQuantity;
  const cost =
    Math.max(input.buyPrice, 0) * saleQuantity +
    allocatedInbound +
    allocatedBuyConsumable +
    allocatedBuyMisc +
    allocatedRefurbishment +
    Math.max(input.outboundFreight, 0) +
    Math.max(input.saleConsumableCost ?? 0, 0) +
    Math.max(input.platformFee ?? 0, 0) +
    Math.max(input.saleMiscCost ?? 0, 0);
  return Math.round((input.salePrice * saleQuantity - cost) * 100) / 100;
}
